export default __webpack_public_path__ + "static/media/safari-browser-settings.72c3d77f.png";